import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const Pager = ({ page, pages, pageSize, onPage, onSize, bottom = false }) => {
  const id = bottom ? "-bottom" : "";
  return (
    <div className="flex items-center gap-1" data-testid={`pager${id}`}>
      {!bottom && (
        <Select value={String(pageSize)} onValueChange={(v) => onSize(Number(v))}>
          <SelectTrigger data-testid="page-size-select" className="mr-2 h-8 w-28 border-slate-700 bg-slate-950 text-xs"><SelectValue /></SelectTrigger>
          <SelectContent className="border-slate-700 bg-slate-900">
            {[50, 100, 200, 500].map((n) => <SelectItem key={n} value={String(n)}>{n} / page</SelectItem>)}
          </SelectContent>
        </Select>
      )}
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={page <= 1} onClick={() => onPage(1)} data-testid={`pager-first${id}`}><ChevronsLeft className="h-4 w-4" /></Button>
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`pager-prev${id}`}><ChevronLeft className="h-4 w-4" /></Button>
      <span className="px-2 font-mono text-xs text-slate-300" data-testid={`pager-label${id}`}>Page {page} / {pages}</span>
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`pager-next${id}`}><ChevronRight className="h-4 w-4" /></Button>
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={page >= pages} onClick={() => onPage(pages)} data-testid={`pager-last${id}`}><ChevronsRight className="h-4 w-4" /></Button>
    </div>
  );
};
